export enum RoomFilterType {
    RoomList,
    City,
}
